import React from 'react';
import ReactDOM from 'react-dom';

export function PortalFrame(props: any) {
  const Frame = props.root;
  return ReactDOM.createPortal(<Frame {...props.props} />, props.node);
}
